import { render } from "./future.vue?vue&type=template&id=30a97305&scoped=true"
import script from "./future.vue?vue&type=script&lang=js"
export * from "./future.vue?vue&type=script&lang=js"

import "./future.vue?vue&type=style&index=0&id=30a97305&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a97305"]])

export default __exports__